module.exports = __webpack_public_path__ + "img/select1-pc-3.1247a4bc.png";